import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import { getLegalEntity, isRussianRegion } from '../config/legalEntity';

export default function SiteFooter() {
    const { t } = useTranslation('common');
    const entity = getLegalEntity();
    const year = new Date().getFullYear();
    const supportEmail = entity.supportEmail
        || (isRussianRegion() ? 'support@sportprogress.ru' : 'support@sportprogress.app');

    return (
        <footer style={{
            textAlign: 'center',
            padding: '28px 16px 32px',
            fontSize: '13px',
            color: '#94a3b8',
            borderTop: '1px solid var(--sp-gray-100)',
            marginTop: '32px',
            lineHeight: 1.6
        }}>
            <Logo variant="light" height={36} style={{ margin: '0 auto 12px', opacity: 0.9 }} />
            <div style={{ margin: '0 0 12px', color: '#64748b' }}>
                <span>{isRussianRegion() ? 'ИП Муровлянникова Д.А.' : 'IE Galstyan Termine Galusti'}</span>
                <br />
                <span>© {year} SportProgress</span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '8px 16px' }}>
                <Link to="/privacy-policy" style={{ color: '#EB3333', textDecoration: 'none' }}>
                    {t('footer.privacyPolicy', { defaultValue: t('footer.privacy') })}
                </Link>
                <Link to="/terms" style={{ color: '#EB3333', textDecoration: 'none' }}>
                    {t('footer.termsOfService', { defaultValue: 'Terms of Service' })}
                </Link>
                <Link to="/refund-policy" style={{ color: '#EB3333', textDecoration: 'none' }}>
                    {t('footer.refundPolicy', { defaultValue: 'Refund Policy' })}
                </Link>
                <a href={`mailto:${supportEmail}`} style={{ color: '#EB3333', textDecoration: 'none' }}>
                    {t('footer.contact', { defaultValue: 'Contact Us' })}
                </a>
            </div>
        </footer>
    );
}
